import { render } from "./PattyReferenceSidekick.vue?vue&type=template&id=279d0fd5&scoped=true"
import script from "./PattyReferenceSidekick.vue?vue&type=script&lang=js"
export * from "./PattyReferenceSidekick.vue?vue&type=script&lang=js"

import "./PattyReferenceSidekick.vue?vue&type=style&index=0&id=279d0fd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279d0fd5"]])

export default __exports__